import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// --- Automatic access-token refresh on 401 (cookie-based JWT) ---
let isRefreshing = false;
let refreshPromise = null;
let pending = [];
const resolvePending = (err) => {
  pending.forEach((cb) => cb(err));
  pending = [];
};

const SKIP_PATHS = ["/auth/login", "/auth/refresh", "/auth/me", "/auth/register", "/auth/logout"];
function shouldSkipRefresh(config) {
  if (!config) return true;
  if (config.skipAuthRefresh) return true;
  const url = config.url || "";
  return SKIP_PATHS.some((p) => url.includes(p));
}

function doRefresh() {
  if (!refreshPromise) {
    refreshPromise = api
      .post("/auth/refresh", null, { skipAuthRefresh: true })
      .finally(() => {
        isRefreshing = false;
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error;
    if (!response || !config || shouldSkipRefresh(config) || response.status !== 401) {
      return Promise.reject(error);
    }
    if (config._retry) return Promise.reject(error);
    config._retry = true;

    const retryPromise = new Promise((resolve, reject) => {
      pending.push((err) => (err ? reject(err) : resolve(api(config))));
    });

    if (!isRefreshing) {
      isRefreshing = true;
      doRefresh()
        .then(() => resolvePending())
        .catch((e) => {
          resolvePending(e);
          if (typeof window !== "undefined") {
            window.dispatchEvent(new CustomEvent("auth:sessionexpired"));
          }
        });
    }
    return retryPromise;
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Algo correu mal. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-PT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function formatEUR(n) {
  if (n == null || isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(Number(n));
}
